export type LocationType = "COUNTRY" | "STATE" | "DISTRICT" | "TEHSIL";